import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "@/session/SessionProvider";

export function RequireAuth({ children }: { children: React.ReactNode }) {
	const { isAuthenticated, isLoading } = useSession();
	const location = useLocation();

	if (isLoading) {
		return (
			<div className="grid min-h-svh place-items-center text-fg-muted">
				Loading…
			</div>
		);
	}

	if (!isAuthenticated) {
		return (
			<Navigate to="/login" replace state={{ from: location.pathname }} />
		);
	}

	return <>{children}</>;
}
